const S2sEvent = (function () {
  const DEFAULT_AUDIO_INPUT_CONFIG = {
    mediaType: 'audio/lpcm',
    sampleRateHertz: 16000,
    sampleSizeBits: 16,
    channelCount: 1,
    audioType: 'SPEECH',
    encoding: 'base64',
  };

  const DEFAULT_AUDIO_OUTPUT_CONFIG = {
    mediaType: 'audio/lpcm',
    sampleRateHertz: 24000,
    sampleSizeBits: 16,
    channelCount: 1,
    encoding: 'base64',
    audioType: 'SPEECH',
  };

  // Utility functions
  /** RequestStartEvent 1 */
  const sessionStart = (inferenceConfig) => ({
    event: { sessionStart: { inferenceConfiguration: inferenceConfig } },
  });

  /**PromptStartEvent 2*/
  const promptStartEvent = (
    promptName,
    audioOutputConfig = DEFAULT_AUDIO_OUTPUT_CONFIG,
    toolConfig
  ) => ({
    event: {
      promptStart: {
        promptName,
        textOutputConfiguration: { mediaType: 'text/plain' },
        audioOutputConfiguration: audioOutputConfig,
        toolUseOutputConfiguration: { mediaType: 'application/json' },
        toolConfiguration: toolConfig,
      },
    },
  });

  /** InputContentStartEvent 3 */
  const contentStartText = (promptName, contentName, role = 'SYSTEM') => ({
    event: {
      contentStart: {
        promptName,
        contentName,
        type: 'TEXT',
        interactive: false,
        role,
        textInputConfiguration: { mediaType: 'text/plain' },
      },
    },
  });

  /**TextInputContent 4 */
  const textInput = (promptName, contentName, systemPrompt) => ({
    event: {
      textInput: {
        promptName,
        contentName,
        content: systemPrompt,
      },
    },
  });

  /** InputContentEndEvent 5 - 8*/
  const contentEnd = (promptName, contentName) => ({
    event: {
      contentEnd: {
        promptName,
        contentName,
      },
    },
  });

  /**Audio 6*/
  const contentStartAudio = (
    promptName,
    contentName,
    audioInputConfig = DEFAULT_AUDIO_INPUT_CONFIG
  ) => ({
    event: {
      contentStart: {
        promptName,
        contentName,
        type: 'AUDIO',
        interactive: true,
        role: 'USER',
        audioInputConfiguration: audioInputConfig,
      },
    },
  });

  /**AudioInputConten 7 */
  const audioInput = (promptName, contentName, content) => ({
    event: {
      audioInput: {
        promptName,
        contentName,
        content,
      },
    },
  });

  /**PromptEndEvent second to last */
  const promptEnd = (promptName) => ({
    event: {
      promptEnd: { promptName },
    },
  });

  /**RequestEndEvent last*/
  const sessionEnd = () => ({
    event: { sessionEnd: {} },
  });

  const voiceOptions = [
    { label: 'Matthew (en-US)', value: 'matthew' },
    { label: 'Tiffany (en-US)', value: 'tiffany' },
    { label: 'Amy (en-GB)', value: 'amy' },
    { label: 'Lupe (Spanish)', value: 'lupe' },
    { label: 'Carlos (Spanish)', value: 'carlos' },
  ];

  return {
    DEFAULT_AUDIO_INPUT_CONFIG,
    DEFAULT_AUDIO_OUTPUT_CONFIG,
    sessionStart,
    promptStartEvent,
    contentStartText,
    textInput,
    contentEnd,
    contentStartAudio,
    audioInput,
    promptEnd,
    sessionEnd,
    voiceOptions,
  };
})();

export default S2sEvent;
